import React from "react";

const HowSetupsWorkPopUp: React.FC = () => (
  <div className="p-6 max-w-md">
    <h2 className="text-4xl font-nostalgic mt-8 mb-8 text-white">
      How do setups work?
    </h2>

    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-medium mb-3 text-white">
          Manual setups stay put.
        </h3>
        <p className="text-white/80 text-base leading-relaxed">
          Any setups you created manually won't disappear if you regenerate.
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium mb-3 text-white">
          Regenerating tweaks, not rewrites.
        </h3>
        <p className="text-white/80 text-base leading-relaxed">
          Hitting regenerate will mostly keep the same setups, with a few small
          changes to improve variety.
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium mb-3 text-white">
          Some people get more than one setup.
        </h3>
        <p className="text-white/80 text-base leading-relaxed">
          We aim for solid compatibility, so it's normal for a few standout
          guests to have multiple setups.
        </p>
      </div>
    </div>
  </div>
);

export default HowSetupsWorkPopUp;
